import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import ManagementReportsReportByDate, { ReportsByDate } from 'scenes/management/reports/reports/by_date'
import ManagementReportsReportsOccupancy from 'scenes/management/reports/reports/occupancy'
import _ from 'lodash'
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import React, { useMemo } from 'react'
import Divider from 'theme/Divider';
import { ThemedValues } from 'styles/themed'

const ManagementReportsDownloadTab = () => {
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );
	
	const renderedReports = useMemo( () => {
		
		const reports = [
			ReportsByDate.bookingsOnDay,
			ReportsByDate.lunchesOnDay,
			ReportsByDate.parkingsOnDay,
			ReportsByDate.transportsOnDay,
			ReportsByDate.employeeBookingCount,
			ReportsByDate.workdays,
			ReportsByDate.commutes,
			ReportsByDate.credits,
		]
		
		return _.map( reports, ( report ) => {
			return (
				<Column
					key={ `report-column-${ report.identifier }` }
					auto>
					
					<ManagementReportsReportByDate
						report={ report }
						multiDate={ true }
						employee={ _employee }
					/>
				</Column>
			);
		})
	}, [ _employee ] )
	
	const renderedCustomReports = useMemo( () => {
		const customReports = [];
		_.forEach( _timeslotKinds, ( timeslotKind ) => {
			if( timeslotKind?.kind === 'custom' ) {
				customReports.push( timeslotKind )
			}
		});
		
		return _.map( customReports, ( timeslotKind ) => {
			return (
				<Column
					key={ `report-by-date-${ timeslotKind.guid }` }
					auto>
					
					<ManagementReportsReportByDate
						timeslotKind={ timeslotKind }
						report={ ReportsByDate.custom }
						multiDate={ true }
						employee={ _employee }
					/>
				</Column>
			);
		});
	}, [ _timeslotKinds, _employee ] )
	
	return (
		<Grid>
			<Container>
				<Row
					space={ ThemedValues.stackSpace }
					chunk={{ xs: 1, md: 2 }}>
					
					{ renderedReports }
				</Row>
				
				<Divider style={staticStyles.dividerMarginTop20MarginBottom20} />
				
				<Row
					space={ ThemedValues.stackSpace }
					chunk={{ xs: 1, md: 2 }}>
					
					<Column auto>
						<ManagementReportsReportsOccupancy
							report={ { identifier: 'occupancy' } }
							multiDate={ true }
							employee={ _employee }
						/>
					</Column>
				</Row>
				
				<Divider style={staticStyles.dividerMarginTop20MarginBottom20} />
				
				<Row
					space={ ThemedValues.stackSpace }
					chunk={{ xs: 1, md: 2 }}>
					
					{ renderedCustomReports }
				</Row>
			</Container>
		</Grid>
	)
}

const staticStyles = StyleSheet.create({
	dividerMarginTop20MarginBottom20: {
		marginTop: 20,
		marginBottom: 20,
	},
});

export default ManagementReportsDownloadTab
